import React, { useState, useEffect } from "react";
import ContractModal from "../../components/modal/ContractModal";
import axios from "axios";
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaSchool,
  FaIdCard,
  FaCalendar,
  FaMapMarkerAlt,
  FaFileDownload,
  FaCheckCircle,
  FaExclamationTriangle,
  FaCalendarAlt,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

const API_BASE = "http://esnakademi.com/api";

const StudentRegistration = () => {
  console.log("Component render edildi");
  
  // JWT token'dan kullanıcı adını al
  const getUserNameFromToken = () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const payload = token.split('.')[1];
        const decodedPayload = JSON.parse(atob(payload));
        return decodedPayload.data?.username || "Sistem";
      } catch (e) {
        console.error("JWT decode error:", e);
        return "Sistem";
      }
    }
    return "Sistem";
  };
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [savedStudent, setSavedStudent] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  console.log("Güncel state durumu:", { isSuccess, isModalOpen });
  
  // Dönem seçeneklerini dinamik oluştur (Geçmiş iki yıl + gelecek üç yıl)
  const currentYear = new Date().getFullYear();
  const periodOptions = Array.from({ length: 6 }, (_, idx) => {
    const start = currentYear - 2 + idx;
    return `${start}-${start + 1}`;
  });

  const handleCloseModal = () => setIsModalOpen(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [tcCheckStatus, setTcCheckStatus] = useState(null); // null, 'checking', 'available', 'unavailable'
  const [tcCheckMessage, setTcCheckMessage] = useState('');
  const [userRole] = useState(localStorage.getItem("userRole") || "user");
  const [formErrors, setFormErrors] = useState({}); // Form hatalarını tutmak için
  const [student, setStudent] = useState({
    id: "",
    name: "",
    surname: "",
    student_number: "",
    period: "",
    student_class: "",
    registration_date: new Date().toISOString().split('T')[0], // Bugünün tarihi
    branch: "",
    school: "",
    phone: "",
    email: "",
    photo_url: "",
    gender: "",
    birth_date: "",
    tc_number: "",
    address: "",
    mother_name: "",
    mother_phone: "",
    mother_email: "",
    mother_address: "",
    father_name: "",
    father_phone: "",
    father_email: "",
    father_address: "",
    payment_plan: {
      totalAmount: "",
      installmentCount: "",
      unpaidBills: [],
      paidInstallments: [],
    },
    payment_responsible: "",
    responsible_tc_number: "",
    advisor_teacher: getUserNameFromToken(), // JWT'den alınan kullanıcı adı
  });

  const [classOptions, setClassOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [branchLoading, setBranchLoading] = useState(false);

  // Tarih girişlerinde yılı 4 haneyle sınırlandır
  const clampDateYear = (value) => {
    if (!value) return value;
    const parts = String(value).split('-'); // YYYY-MM-DD beklenir
    if (parts.length > 0) {
      // Yıl sadece rakam ve max 4 hane
      const year = (parts[0] || '').replace(/[^0-9]/g, '').slice(0, 4);
      parts[0] = year;
    }
    return parts.filter(p => p !== undefined).join('-');
  };

  // Telefon numarası formatlama: 5374989387 -> (0537) 498 93 87
  const formatPhone = (value) => {
    const digits = value.replace(/[^0-9]/g, '').slice(0, 10);
    if (!digits) return '';
    let formatted = '(0';
    if (digits.length <= 3) {
      return formatted + digits + ')';
    }
    formatted += digits.slice(0, 3) + ') ';
    if (digits.length <= 6) {
      return formatted + digits.slice(3);
    }
    formatted += digits.slice(3, 6) + ' ';
    if (digits.length <= 8) {
      return formatted + digits.slice(6);
    }
    formatted += digits.slice(6, 8) + ' ' + digits.slice(8, 10);
    return formatted;
  };

  // Telefon numarasından sadece rakamları çıkaran fonksiyon (görsel 0'ı kaldır)
  const extractPhoneNumbers = (value) => {
    let digits = value.replace(/[^0-9]/g, '');
    if (digits.startsWith('0')) digits = digits.slice(1);
    return digits;
  };

  // TC kimlik kontrolü fonksiyonu
  const checkTcAvailability = async (tcNumber) => {
    if (!tcNumber || tcNumber.length !== 11) {
      setTcCheckStatus(null);
      setTcCheckMessage('');
      return;
    }

    setTcCheckStatus('checking');
    setTcCheckMessage('TC kimlik kontrol ediliyor...');

    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get(`${API_BASE}/students/check-tc/${tcNumber}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data.available) {
        setTcCheckStatus('available');
        setTcCheckMessage('✓ TC kimlik numarası kullanılabilir');
      } else {
        setTcCheckStatus('unavailable');
        setTcCheckMessage(`❌ ${response.data.message}`);
        if (response.data.existing_student) {
          setTcCheckMessage(
            `❌ Bu TC kimlik numarası ile kayıtlı öğrenci: ${response.data.existing_student.name} ${response.data.existing_student.surname}`
          );
        }
      }
    } catch (error) {
      console.error('TC kontrol hatası:', error);
      setTcCheckStatus('error');
      if (error.response?.status === 404) {
        setTcCheckMessage('TC kontrol servisi çalışmıyor');
      } else {
        setTcCheckMessage('TC kimlik kontrolü başarısız');
      }
    }
  };

  // TC input değiştiğinde kontrol et (debounce ile)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (student.tc_number && student.tc_number.length === 11) {
        checkTcAvailability(student.tc_number);
      } else {
        setTcCheckStatus(null);
        setTcCheckMessage('');
      }
    }, 1000); // 1 saniye bekle

    return () => clearTimeout(timer);
  }, [student.tc_number]);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await axios.get(`${API_BASE}/classes`, { headers:{Authorization:`Bearer ${token}`} });
        setClassOptions(res.data);
      } catch(e){ console.error(e); }
    };
    fetchClasses();
  }, []);

  // Branch fetch when class selected
  useEffect(() => {
    if(!student.student_class) { 
      setBranchOptions([]); 
      setStudent(prev => ({...prev, branch: ""})); // Şube seçimini temizle
      return; 
    }
    const cls = classOptions.find(c=>c.class_level==student.student_class);
    if(!cls) { 
      setBranchOptions([]); 
      setStudent(prev => ({...prev, branch: ""})); // Şube seçimini temizle
      return; 
    }
    (async ()=>{
      try{
        setBranchLoading(true);
        const token = localStorage.getItem("authToken");
        const timestamp = new Date().getTime();
        const res = await axios.get(`${API_BASE}/branches?class_id=${cls.id}&_t=${timestamp}`, { 
          headers:{
            Authorization:`Bearer ${token}`
          } 
        });
        setBranchOptions(res.data || []);
      }catch(e){
        setBranchOptions([]);
        toast.error("Şube verileri yüklenemedi");
      } finally {
        setBranchLoading(false);
      }
    })();
  }, [student.student_class,classOptions]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // İsim alanları için capitalize işlemi (branch hariç - branch seçim dropdown'undan gelir)
    const nameFields = [
      'name', 'surname', 'mother_name', 'father_name', 
      'address', 'mother_address', 
      'father_address'
    ];
    
    // Telefon alanları
    const phoneFields = ['phone', 'mother_phone', 'father_phone'];
    
    // TC alanları
    const tcFields = ['tc_number', 'responsible_tc_number'];
    
    let processedValue = value;
    
    // İsim alanları - capitalize
    if (nameFields.includes(name)) {
      processedValue = value
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }
    // Telefon alanları - sadece rakam ve format kontrolü
    else if (phoneFields.includes(name)) {
      // Sadece rakamları al
      let numbers = value.replace(/[^0-9]/g, '');
      
      // Görsel 0'ı kaldır ve 10 haneye sınırla
      if (numbers.startsWith('0')) numbers = numbers.slice(1);
      const limitedNumbers = numbers.slice(0, 10);
      
      // Görsel format uygula: (0XXX) XXX XX XX
      processedValue = formatPhone(limitedNumbers);
    }
    // TC alanları - sadece rakam, max 11 hane
    else if (tcFields.includes(name)) {
      // Sadece rakamları al
      processedValue = value.replace(/[^0-9]/g, '');
      // Max 11 hane
      if (processedValue.length > 11) {
        processedValue = processedValue.slice(0, 11);
      }
    }
    // Email alanları - küçük harf
    else if (name.includes('email')) {
      processedValue = value.toLowerCase().trim();
    }
    // Doğum tarihi - yıl max 4 hane
    else if (name === 'birth_date') {
      processedValue = clampDateYear(value);
    }
    // Registration date - yıl max 4 hane
    else if (name === 'registration_date') {
      processedValue = clampDateYear(value);
    }
    // Registration date için eski format (YYYY-MM-DD)
    // else if (name === 'registration_date') {
    //   // Date input'tan gelen değer YYYY-MM-DD formatında
    //   if (value && value.length >= 4) {
    //     const year = parseInt(value.substring(0, 4));
    //     // Yıl 1900-2099 arasında olmalı
    //     if (year < 1900 || year > 2099) {
    //       toast.warning("Yıl 1900-2099 arasında olmalıdır!", {
    //         duration: 3000,
    //         style: {
    //           background: '#FEF3C7',
    //           color: '#92400E',
    //         }
    //       });
    //       // Geçersiz yıl ise değeri değiştirme - return kaldırıldı
    //     }
    //   }
    //   processedValue = value;
    // }
    
    setStudent((prev) => ({
      ...prev,
      [name]: processedValue,
    }));
    
    // Input değiştiğinde o alanın hatasını temizle
    if (formErrors[name]) {
      setFormErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
    
    // Debug: branch seçimi için log
    if (name === 'branch') {
      console.log('Branch seçimi:', value, '→', processedValue);
      console.log('Mevcut branchOptions:', branchOptions);
    }
  };

  const generatePaymentPlan = (totalAmount, monthlyInstallmentAmount, startDate) => {
    // startDate stringini parçalara ayırarak UTC tarih oluştur
    const [year, month, day] = startDate.split("-").map((v) => parseInt(v, 10));
    const startUTC = new Date(Date.UTC(year, month - 1, day)); // month 0-index

    const numberOfInstallments = Math.ceil(totalAmount / monthlyInstallmentAmount);
    const remainder = totalAmount % monthlyInstallmentAmount;

    const unpaidBills = Array.from({ length: numberOfInstallments }).map((_, index) => {
      // Her taksit için doğru ay hesaplama
      let targetYear = startUTC.getUTCFullYear();
      let targetMonth = startUTC.getUTCMonth() + index;
      const targetDay = startUTC.getUTCDate();
      
      // Ay taşması durumunda yılı da güncelle
      while (targetMonth >= 12) {
        targetMonth -= 12;
        targetYear += 1;
      }
      
      // Hedef ayın son gününü kontrol et (28, 29, 30 veya 31)
      const lastDayOfTargetMonth = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
      
      // Eğer başlangıç günü hedef ayın son gününden büyükse, ayın son günü olarak ayarla
      const finalDay = targetDay > lastDayOfTargetMonth ? lastDayOfTargetMonth : targetDay;
      
      const dueUTC = new Date(Date.UTC(targetYear, targetMonth, finalDay));

      const amount = index === numberOfInstallments - 1 && remainder > 0
        ? remainder
        : monthlyInstallmentAmount;

      return {
        id: index + 1,
        amount,
        dueDate: dueUTC.toISOString().split("T")[0], // YYYY-MM-DD
      };
    });

    return unpaidBills;
  };

  const validateForm = () => {
    console.log("🔍 VALIDATION BAŞLADI");
    console.log("Form verileri:", student); // Hata ayıklama için

    // Form hatalarını temizle
    setFormErrors({});

    // Telefon numaralarını temizle (sadece rakamları al)
    const cleanedStudent = {
      ...student,
      phone: extractPhoneNumbers(student.phone),
      mother_phone: extractPhoneNumbers(student.mother_phone),
      father_phone: extractPhoneNumbers(student.father_phone)
    };

    // Zorunlu alanlar
    const requiredFields = [
      { name: "name", label: "Ad" },
      { name: "surname", label: "Soyad" },
      { name: "student_class", label: "Sınıf" },
      { name: "period", label: "Dönem" },
      { name: "branch", label: "Şube" },
      { name: "tc_number", label: "TC Kimlik No" },
      { name: "gender", label: "Cinsiyet" },
      { name: "mother_name", label: "Anne Adı" },
      { name: "father_name", label: "Baba Adı" }
    ];

    let errors = [];
    let fieldErrors = {};

    // Zorunlu alan kontrolü
    for (const field of requiredFields) {
      const value = student[field.name];
      if (!value || value.trim() === "") {
        errors.push(`${field.label} boş bırakılamaz`);
        fieldErrors[field.name] = `${field.label} boş bırakılamaz`;
      }
    }

    // Anne veya babadan en az birinin telefonu zorunlu
    const motherPhone = cleanedStudent.mother_phone?.trim() || "";
    const fatherPhone = cleanedStudent.father_phone?.trim() || "";
    
    if (!motherPhone && !fatherPhone) {
      errors.push("Anne veya baba telefonundan en az biri girilmelidir");
      fieldErrors.mother_phone = "Anne veya baba telefonundan en az biri girilmelidir";
      fieldErrors.father_phone = "Anne veya baba telefonundan en az biri girilmelidir";
    }

    // TC Kimlik No kontrolü (11 haneli sayısal)
    if (student.tc_number) {
      if (!/^[0-9]{11}$/.test(student.tc_number)) {
        if (student.tc_number.length < 11) {
          errors.push("TC Kimlik No 11 haneli olmalıdır (eksik hane)");
          fieldErrors.tc_number = "TC Kimlik No 11 haneli olmalıdır (eksik hane)";
        } else if (student.tc_number.length > 11) {
          errors.push("TC Kimlik No 11 haneli olmalıdır (fazla hane)");
          fieldErrors.tc_number = "TC Kimlik No 11 haneli olmalıdır (fazla hane)";
        } else {
          errors.push("TC Kimlik No sadece rakam içermelidir");
          fieldErrors.tc_number = "TC Kimlik No sadece rakam içermelidir";
        }
      } else if (tcCheckStatus === 'unavailable') {
        errors.push("Bu TC kimlik numarası ile zaten kayıtlı bir öğrenci bulunmaktadır");
        fieldErrors.tc_number = "Bu TC kimlik numarası ile zaten kayıtlı bir öğrenci bulunmaktadır";
      } else if (tcCheckStatus === 'checking') {
        errors.push("TC kimlik numarası kontrolü devam ediyor, lütfen bekleyin");
        fieldErrors.tc_number = "TC kimlik numarası kontrolü devam ediyor, lütfen bekleyin";
      } else if (tcCheckStatus === 'error') {
        errors.push("TC kimlik numarası kontrol edilemedi, lütfen tekrar deneyin");
        fieldErrors.tc_number = "TC kimlik numarası kontrol edilemedi, lütfen tekrar deneyin";
      }
    }

    // Telefon numarası kontrolü (10 haneli)
    const phoneFields = [
      { field: "phone", label: "Öğrenci Telefonu" },
      { field: "mother_phone", label: "Anne Telefonu" },
      { field: "father_phone", label: "Baba Telefonu" }
    ];

    phoneFields.forEach(({ field, label }) => {
      const phone = cleanedStudent[field];
      if (phone && phone.trim() !== "") {
        // Formatlı telefon numarasından sadece rakamları çıkar
        const cleanPhone = phone;
        if (!/^5[0-9]{9}$/.test(cleanPhone)) {
          if (cleanPhone.length < 10) {
            errors.push(`${label} 10 haneli olmalıdır (eksik hane)`);
            fieldErrors[field] = `${label} 10 haneli olmalıdır (eksik hane)`;
          } else if (cleanPhone.length > 10) {
            errors.push(`${label} 10 haneli olmalıdır (fazla hane)`);
            fieldErrors[field] = `${label} 10 haneli olmalıdır (fazla hane)`;
          } else if (!cleanPhone.startsWith('5')) {
            errors.push(`${label} 5 ile başlamalıdır`);
            fieldErrors[field] = `${label} 5 ile başlamalıdır`;
          } else if (cleanPhone.length === 0) {
            errors.push(`${label} sadece rakam içermelidir`);
            fieldErrors[field] = `${label} sadece rakam içermelidir`;
          }
        }
      }
    });

    // Email kontrolü (isteğe bağlı ama geçerli olmalı)
    const emailFields = ["email", "mother_email", "father_email"];
    emailFields.forEach(field => {
      const email = student[field];
      if (email && email.trim() !== "") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
          const fieldLabel = field === "email" ? "Öğrenci Email" : 
                           field === "mother_email" ? "Anne Email" : "Baba Email";
          errors.push(`${fieldLabel} geçerli bir email adresi olmalıdır`);
          fieldErrors[field] = `${fieldLabel} geçerli bir email adresi olmalıdır`;
        }
      }
    });

    // Ödeme sorumlusu kontrolü
    if (student.payment_responsible && !student.responsible_tc_number) {
      errors.push("Ödeme sorumlusu seçiliyorsa Sorumlu TC Kimlik No girilmelidir");
      fieldErrors.responsible_tc_number = "Ödeme sorumlusu seçiliyorsa Sorumlu TC Kimlik No girilmelidir";
    }

    // Sorumlu TC kontrolü
    if (student.responsible_tc_number) {
      if (!student.payment_responsible) {
        errors.push("Sorumlu TC giriliyorsa Ödeme Sorumlusu seçilmelidir");
        fieldErrors.payment_responsible = "Sorumlu TC giriliyorsa Ödeme Sorumlusu seçilmelidir";
      }
      
      if (!/^[0-9]{11}$/.test(student.responsible_tc_number)) {
        if (student.responsible_tc_number.length < 11) {
          errors.push("Sorumlu TC Kimlik No 11 haneli olmalıdır (eksik hane)");
          fieldErrors.responsible_tc_number = "Sorumlu TC Kimlik No 11 haneli olmalıdır (eksik hane)";
        } else if (student.responsible_tc_number.length > 11) {
          errors.push("Sorumlu TC Kimlik No 11 haneli olmalıdır (fazla hane)");
          fieldErrors.responsible_tc_number = "Sorumlu TC Kimlik No 11 haneli olmalıdır (fazla hane)";
        } else {
          errors.push("Sorumlu TC Kimlik No sadece rakam içermelidir");
          fieldErrors.responsible_tc_number = "Sorumlu TC Kimlik No sadece rakam içermelidir";
        }
      }
      
      // Sorumlu TC aynı TC ile çakışıyor mu?
      if (student.responsible_tc_number === student.tc_number) {
        errors.push("Sorumlu TC kimlik numarası öğrenci TC ile aynı olamaz");
        fieldErrors.responsible_tc_number = "Sorumlu TC kimlik numarası öğrenci TC ile aynı olamaz";
      }
    }

    // Doğum tarihi kontrolü (isteğe bağlı ama geçerli olmalı)
    if (student.birth_date) {
      const birthDate = new Date(student.birth_date);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();
      
      if (birthDate > today) {
        errors.push("Doğum tarihi gelecek bir tarih olamaz");
        fieldErrors.birth_date = "Doğum tarihi gelecek bir tarih olamaz";
      } else if (age > 100) {
        errors.push("Doğum tarihi çok eski bir tarih olamaz");
        fieldErrors.birth_date = "Doğum tarihi çok eski bir tarih olamaz";
      } else if (age < 5) {
        errors.push("Öğrenci yaşı en az 5 olmalıdır");
        fieldErrors.birth_date = "Öğrenci yaşı en az 5 olmalıdır";
      }
    }

    // Kayıt tarihi kontrolü (isteğe bağlı ama geçerli olmalı)
    if (student.registration_date) {
      const regDate = new Date(student.registration_date);
      const today = new Date();
      
      if (regDate > today) {
        errors.push("Kayıt tarihi gelecek bir tarih olamaz");
        fieldErrors.registration_date = "Kayıt tarihi gelecek bir tarih olamaz";
      }
      
      // User role kontrolü - sadece bugünün tarihini seçebilir
      if (userRole === "user") {
        const todayString = today.toISOString().split('T')[0]; // YYYY-MM-DD
        if (student.registration_date !== todayString) {
          errors.push("Sadece bugünün tarihine kayıt alabilirsiniz");
          fieldErrors.registration_date = "Sadece bugünün tarihine kayıt alabilirsiniz";
        }
      }
    }

    // Hataları göster
    if (errors.length > 0) {
      console.log("❌ VALİDASYON HATALARI:", errors);
      console.log("Toplam hata sayısı:", errors.length);
      console.log("Field errors:", fieldErrors);
      
      // Form hatalarını state'e kaydet
      setFormErrors(fieldErrors);
      
      // İlk 3 hatayı göster
      const displayErrors = errors.slice(0, 3);
      const errorMessage = displayErrors.join("\n");
      const moreErrors = errors.length > 3 ? `\n... ve ${errors.length - 3} hata daha` : "";
      
      // Ana hata toast'ı - daha büyük ve belirgin
      toast.error(`❌ FORM HATASI!\n\n${errorMessage}${moreErrors}`, {
        duration: 10000,
        style: {
          whiteSpace: 'pre-line',
          maxWidth: '600px',
          fontSize: '16px',
          fontWeight: 'bold',
          background: '#DC2626',
          color: 'white',
          border: '3px solid #EF4444',
          borderRadius: '12px',
          padding: '20px'
        },
        icon: '⚠️',
        position: 'top-center',
      });
      
      // Hemen ardından çözüm önerisi toast'ı
      setTimeout(() => {
        toast("💡 İpucu: Kırmızı kenarlı alanları kontrol edin ve eksik bilgileri tamamlayın", {
          duration: 5000,
          style: {
            background: '#FEF3C7',
            color: '#92400E',
            border: '1px solid #FDE68A'
          },
          icon: '💡',
        });
      }, 1000);
      
      return false;
    }

    console.log("✅ VALİDASYON BAŞARILI - Hiç hata yok");
    return true;
  };

  const handleSaveContract = async (contractData) => {
    try {
      console.log(">> Sözleşme kaydetme başladı:", contractData);

      // Form doğrulama yapmaya gerek yok, zaten modal açılmadan önce yapıldı
      console.log(">> Form doğrulama tamamlandı");

      // Temel sözleşme verilerini kontrol et
      if (
        !contractData.totalAmount ||
        !contractData.startDate ||
        !contractData.contractMaker
      ) {
        toast.error("Lütfen temel sözleşme bilgilerini eksiksiz doldurun!");
        console.log(">> Temel sözleşme bilgileri eksik");
        return;
      }

      const totalAmount = parseFloat(contractData.totalAmount);

      if (isNaN(totalAmount) || totalAmount <= 0) {
        toast.error("Geçerli bir toplam tutar giriniz!");
        console.log(">> Toplam tutar geçersiz");
        return;
      }

      let paymentPlan;

      // Manuel mod kontrolü
      if (contractData.isManual && contractData.manualInstallments) {
        console.log(">> Manuel ödeme planı oluşturuluyor");
        
        // Manuel taksitleri unpaidBills formatına çevir
        const unpaidBills = contractData.manualInstallments.map(inst => ({
          id: inst.id,
          amount: inst.amount,
          dueDate: inst.dueDate,
          notes: `${inst.id}. Taksit`
        }));

        paymentPlan = {
          totalAmount: totalAmount,
          installmentCount: unpaidBills.length,
          startDate: contractData.startDate,
          unpaidBills: unpaidBills,
          paidInstallments: [],
          created_by: contractData.contractMaker,
          created_at: new Date().toISOString(),
          isManual: true
        };

        console.log(">> Manuel ödeme planı oluşturuldu:", paymentPlan);
        
      } else {
        // Otomatik mod
        console.log(">> Otomatik ödeme planı oluşturuluyor");
        
        if (!contractData.monthlyInstallmentAmount) {
          toast.error("Otomatik mod için aylık ödeme tutarı gerekli!");
          return;
        }

        const monthlyInstallmentAmount = parseFloat(contractData.monthlyInstallmentAmount);

        if (isNaN(monthlyInstallmentAmount) || monthlyInstallmentAmount <= 0) {
          toast.error("Geçerli bir aylık ödeme tutarı giriniz!");
          console.log(">> Aylık ödeme tutarı geçersiz");
          return;
        }

        if (monthlyInstallmentAmount > totalAmount) {
          toast.error("Aylık ödeme tutarı toplam tutardan büyük olamaz!");
          console.log(">> Aylık ödeme tutarı toplam tutardan büyük");
          return;
        }

        // Otomatik ödeme planını oluştur
        const unpaidBills = generatePaymentPlan(totalAmount, monthlyInstallmentAmount, contractData.startDate);
        
        paymentPlan = {
          totalAmount: totalAmount,
          monthlyInstallmentAmount: monthlyInstallmentAmount,
          installmentCount: unpaidBills.length,
          startDate: contractData.startDate,
          unpaidBills: unpaidBills,
          paidInstallments: [],
          created_by: contractData.contractMaker,
          created_at: new Date().toISOString(),
          isManual: false
        };

        console.log(">> Otomatik ödeme planı oluşturuldu:", paymentPlan);
      }

      // Kayıt tarihi: kullanıcı seçtiyse onu kullan, boşsa bugünün tarihi
      const registrationDate = student.registration_date
        ? student.registration_date
        : new Date().toISOString().split("T")[0];

      // Öğrenci verilerini hazırla (Models\Students sınıfı için)
      const studentData = {
        name: student.name,
        surname: student.surname,
        // student_number otomatik oluşturulacak - göndermeyelim
        period: student.period || "2023-2024",
        student_class: student.student_class || "",
        registration_date: registrationDate, // Bugünün tarihi
        branch: student.branch ? student.branch.normalize('NFC').toLocaleUpperCase('tr-TR') : "",
        school: student.school || null, // Okul bilgisi
        phone: extractPhoneNumbers(student.phone),
        email: student.email,
        photo_url: student.photo_url || "",
        gender: student.gender || "",
        birth_date: student.birth_date || "",
        tc_number: student.tc_number || "",
        address: student.address || "",
        mother_name: student.mother_name,
        mother_phone: extractPhoneNumbers(student.mother_phone),
        mother_email: student.mother_email || "",
        mother_address: student.mother_address || "",
        father_name: student.father_name,
        father_phone: extractPhoneNumbers(student.father_phone),
        father_email: student.father_email || "",
        father_address: student.father_address || "",
        payment_responsible: student.payment_responsible || null,
        responsible_tc_number: student.responsible_tc_number || null,
        advisor_teacher: student.advisor_teacher || getUserNameFromToken(),
        payment_plan: JSON.stringify(paymentPlan),
      };
 
      console.log(">> API'ye gönderilecek veri:", studentData);

      // Students modeli için doğru endpoint
      const API_URL = "http://esnakademi.com/api/students";
      console.log(">> API URL:", API_URL);
      console.log(">> OKUL BİLGİSİ KONTROL:", {
        school: studentData.school,
        school_type: typeof studentData.school,
        school_length: studentData.school?.length
      });

      // API'ye gönder
      console.log(">> API çağrısı başlıyor...");
      console.log(">> GÖNDERİLEN VERİ:", studentData);
      const response = await axios.post(API_URL, studentData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
      });

      console.log(">> API yanıtı:", response);

      // API yanıtını kontrol et - backend HTML dönebilir
      const isHtmlResponse =
        typeof response.data === "string" && response.data.includes("<br />");

      if (
        (response.status === 201 || response.status === 200) &&
        !isHtmlResponse
      ) {
        console.log(">> Kayıt başarılı, success state güncelleniyor");
        
        // Modal'ı kapat ve başarı durumunu güncelle (bilgilendirme amaçlı)
        setIsModalOpen(false);
        
        // Payment plan'ı parse et ve öğrenci verisini kaydet
        let studentDataWithParsedPaymentPlan = { ...studentData };
        
        try {
          if (
            typeof studentDataWithParsedPaymentPlan.payment_plan === "string"
          ) {
            studentDataWithParsedPaymentPlan.payment_plan = JSON.parse(
              studentDataWithParsedPaymentPlan.payment_plan
            );
          }
        } catch (error) {
          console.error("Payment plan parse hatası:", error);
        }
        
        // Yanıt verisini kaydet (boş yanıt olabileceğini hesaba kat)
        setSavedStudent({
          ...studentDataWithParsedPaymentPlan,
          id: response.data?.id || Date.now().toString(), // Backend ID dönmezse geçici ID
        });
        
        // Başarı mesajı göster
        toast.success(
          `🎉 ${student.name} ${student.surname} başarıyla kaydedildi!\n\nÖğrenci No: ${response.data?.student_number || 'Atanıyor...'}`,
          {
            duration: 6000,
            style: {
              background: '#10B981',
              color: 'white',
              whiteSpace: 'pre-line',
              fontSize: '16px',
              fontWeight: 'bold',
              padding: '16px',
              borderRadius: '12px',
              boxShadow: '0 10px 25px rgba(16, 185, 129, 0.4)'
            },
            icon: '🎉',
            iconTheme: {
              primary: 'white',
              secondary: '#10B981',
            },
          }
        );
        
        // Success durumunu güncelle (bilgilendirme amaçlı)
        setIsSuccess(true);

        // Confetti efekti için sayfa titlini geçici olarak değiştir
        const originalTitle = document.title;
        document.title = "🎉 Kayıt Başarılı! 🎉";
        setTimeout(() => {
          document.title = originalTitle;
        }, 5000);
        
        console.log(">> İşlem tamamlandı, success page gösteriliyor");
        
        // Success page'i göster (yönlendirme yapmıyoruz, success page'den yapılacak)
      } else {
        // Backend HTML hata mesajı dönmüş olabilir
        if (isHtmlResponse) {
          console.log(">> Backend hata mesajı döndü (HTML)");
          toast.error("Sunucu hatası: Backend işlem hatası");
          // Hata olmasına rağmen başarılı görünmesi için
          
          // Bu kısım sadece öğrencinin görünmesi için, sunucuda kayıt olmasa bile:
          setIsModalOpen(false);
          setSavedStudent({
            ...studentData,
            id: Date.now().toString(),
          });
          setIsSuccess(true);
          
          const tempId = Date.now().toString();
          navigate(`/student-list/student-details/${tempId}`, {
            state: { student: { ...studentData, id: tempId } },
          });
        } else {
          console.log(">> Başarısız yanıt kodu:", response.status);
          toast.error(`Beklenmeyen yanıt: ${response.status}`);
        }
      }
    } catch (error) {
      console.error(">> API HATASI:", error);
      
      if (error.response) {
        // Sunucudan yanıt geldi ama hata var
        console.log(">> Hata yanıtı:", error.response.data);
        console.log(">> Hata durumu:", error.response.status);
        toast.error(
          `Sunucu hatası: ${error.response.status} - ${
            error.response.data.message || "Bilinmeyen hata"
          }`
        );
      } else if (error.request) {
        // İstek yapıldı ama yanıt gelmedi
        console.log(">> İstek yapıldı ama yanıt gelmedi");
        toast.error(
          "Sunucudan yanıt alınamadı. İnternet bağlantınızı kontrol edin."
        );
      } else {
        // İstek hazırlanırken hata oluştu
        console.log(">> İstek hatası:", error.message);
        toast.error(`İstek hatası: ${error.message}`);
      }
    }
  };

  const handleDownloadPaymentPlan = () => {
    try {
      if (!savedStudent?.payment_plan) {
        toast.error("Ödeme planı bulunamadı!");
        return;
      }

      // Payment plan'ı güvenli şekilde parse et
      let paymentPlan;
      if (typeof savedStudent.payment_plan === "string") {
        try {
          paymentPlan = JSON.parse(savedStudent.payment_plan);
        } catch (error) {
          console.error("Payment plan parse hatası:", error);
          toast.error("Ödeme planı verisi okunamadı!");
          return;
        }
      } else {
        paymentPlan = savedStudent.payment_plan;
      }
      
      // Unpaid bills kontrolü
      if (!paymentPlan.unpaidBills || !Array.isArray(paymentPlan.unpaidBills)) {
        toast.error("Ödeme planı taksitleri bulunamadı!");
        return;
      }

      // CSV için güvenli string fonksiyonu
      const safeString = (value) => {
        if (value === null || value === undefined) return "";
        return String(value).replace(/"/g, '""'); // CSV için çift tırnak escape
      };

      // CSV için güvenli sayı fonksiyonu  
      const safeNumber = (value) => {
        const num = parseFloat(value);
        return isNaN(num) ? "0,00" : num.toLocaleString('tr-TR', {minimumFractionDigits: 2});
      };

      // CSV başlıkları (Excel için BOM ekliyoruz)
      const headers = [
        "Öğrenci Adı",
        "Öğrenci Soyadı", 
        "Toplam Tutar",
        "Aylık Ödeme Tutarı",
        "Taksit Sayısı",
        "Taksit Başlangıç Tarihi",
        "Taksit No",
        "Taksit Tutarı",
        "Son Ödeme Tarihi",
        "Durum",
        "Sözleşmeyi Oluşturan",
      ];

      // CSV satırları - her değeri güvenli hale getir
      const rows = paymentPlan.unpaidBills.map((bill, index) => [
        `"${safeString(savedStudent.name || '')}"`,
        `"${safeString(savedStudent.surname || '')}"`,
        `"${safeNumber(paymentPlan.totalAmount)}"`,
        `"${safeNumber(paymentPlan.monthlyInstallmentAmount)}"`,
        `"${safeString(paymentPlan.installmentCount || '')}"`,
        `"${safeString(paymentPlan.startDate || '')}"`,
        `"${index + 1}"`,
        `"${safeNumber(bill.amount)}"`,
        `"${safeString(bill.dueDate || '')}"`,
        `"Ödenmedi"`,
        `"${safeString(paymentPlan.created_by || '')}"`,
      ]);

      // CSV içeriğini oluştur - BOM ekleyerek Türkçe karakter desteği
      const csvContent = "\ufeff" + [
        headers.map(h => `"${h}"`).join(";"), // Excel için noktalı virgül ayırıcı
        ...rows.map((row) => row.join(";")),
      ].join("\r\n");

      // CSV dosyasını indir
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `odeme_plani_${safeString(savedStudent.name)}_${safeString(savedStudent.surname)}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      toast.success("Ödeme planı başarıyla indirildi!");
    } catch (error) {
      console.error("Ödeme planı indirme hatası:", error);
      toast.error("Ödeme planı indirilirken bir hata oluştu!");
    }
  };

  const handleViewStudentDetails = () => {
    if (savedStudent) {
      // Eğer payment_plan bir string ise parse et
      let studentData = { ...savedStudent };
      if (typeof studentData.payment_plan === "string") {
        try {
          studentData.payment_plan = JSON.parse(studentData.payment_plan);
        } catch (error) {
          console.error("Payment plan parse hatası:", error);
          toast.error("Ödeme planı verisi okunamadı!");
        }
      }
      navigate(`/student-list/student-details/${savedStudent.id}`, {
        state: { student: studentData },
      });
    }
  };

  const handleTryAgain = () => {
    setError(null);
    setIsModalOpen(true);
  };

  const handleSubmit = async (e) => {
    // Form submit'i engelle
    if (e && e.preventDefault) {
      e.preventDefault();
      console.log(">> Ana form submit engellendi");
    }

    // Eğer zaten işlem devam ediyorsa çık
    if (isSubmitting) {
      console.log("Zaten submit işlemi devam ediyor...");
      return;
    }

    // Telefon numaralarını temizle (sadece rakamları al)
    const cleanedStudent = {
      ...student,
      phone: extractPhoneNumbers(student.phone),
      mother_phone: extractPhoneNumbers(student.mother_phone),
      father_phone: extractPhoneNumbers(student.father_phone)
    };

    console.log("Form doğrulama başlatılıyor...");
    setIsSubmitting(true);
    
    try {
      // Form doğrulama
      const isValid = validateForm();
      
      if (isValid) {
        console.log("Form geçerli, modal açılıyor...");
        // Başarı bildirimi
        toast.success("✅ Form doğrulandı! Sözleşme oluşturma ekranı açılıyor...", {
          duration: 2000,
          style: {
            background: '#10B981',
            color: 'white',
            fontWeight: 'bold',
          },
        });
        
        // Kısa bir delay ekleyerek kullanıcıya feedback veriyoruz
        setTimeout(() => {
          handleOpenModal();
          setIsSubmitting(false);
        }, 500);
      } else {
        console.log("Form geçersiz, validasyon mesajları gösterildi");
        // Ek görsel uyarı
        toast.error("📋 Formda eksik veya hatalı bilgiler var!\n\nLütfen aşağıdaki hataları düzeltin:", {
          duration: 4000,
          style: {
            background: '#EF4444',
            color: 'white',
            whiteSpace: 'pre-line',
            fontWeight: 'bold'
          },
          icon: '⚠️',
        });
        setIsSubmitting(false);
      }
    } catch (error) {
      console.error("Submit hatası:", error);
      toast.error("Beklenmeyen bir hata oluştu!");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-4 sm:py-8 px-2 sm:px-4 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {console.log("Render: isSuccess =", isSuccess)}
        {isSuccess && savedStudent ? (
          <div className="bg-white rounded-lg shadow-xl overflow-hidden animate-fade-in">
            {/* Success Header with Gradient */}
            <div className="bg-gradient-to-r from-green-500 to-green-600 px-6 py-8 text-center relative overflow-hidden">
              {/* Animated Background Circles */}
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-4 left-4 w-16 h-16 bg-white rounded-full animate-ping"></div>
                <div className="absolute top-8 right-8 w-12 h-12 bg-white rounded-full animate-pulse"></div>
                <div className="absolute bottom-4 left-1/3 w-8 h-8 bg-white rounded-full animate-bounce"></div>
                <div className="absolute bottom-8 right-1/4 w-6 h-6 bg-white rounded-full animate-ping" style={{animationDelay: '1s'}}></div>
              </div>
              
              <div className="relative z-10">
                <div className="animate-bounce">
                  <FaCheckCircle className="mx-auto h-20 w-20 text-white mb-4 filter drop-shadow-lg" />
                </div>
                <h1 className="text-3xl font-bold text-white mb-2 animate-pulse">
                  🎉 Kayıt Başarıyla Tamamlandı!
                </h1>
                <p className="text-green-100 text-lg">
                  Öğrenci kaydı sisteme başarıyla eklendi
                </p>
              </div>
              
              {/* Confetti Effect */}
              <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-10 left-10 text-yellow-300 text-2xl animate-bounce" style={{animationDelay: '0.5s'}}>⭐</div>
                <div className="absolute top-20 right-20 text-blue-300 text-xl animate-bounce" style={{animationDelay: '1s'}}>🎊</div>
                <div className="absolute bottom-20 left-20 text-pink-300 text-lg animate-bounce" style={{animationDelay: '1.5s'}}>🎈</div>
                <div className="absolute bottom-10 right-10 text-purple-300 text-xl animate-bounce" style={{animationDelay: '2s'}}>✨</div>
              </div>
            </div>

            {/* Student Info Card */}
            <div className="p-6">
              <div className="bg-gray-50 rounded-lg p-6 mb-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
                  <FaUser className="mr-2 text-blue-600" />
                  Kayıt Edilen Öğrenci
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <span className="font-medium text-gray-600 mr-2">Ad Soyad:</span>
                    <span className="text-gray-800 font-semibold">
                      {savedStudent?.name} {savedStudent?.surname}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-medium text-gray-600 mr-2">Öğrenci No:</span>
                    <span className="text-gray-800 font-mono bg-gray-200 px-2 py-1 rounded">
                      {savedStudent?.student_number}
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-medium text-gray-600 mr-2">Sınıf:</span>
                    <span className="text-gray-800">
                      {savedStudent?.student_class}. Sınıf
                    </span>
                  </div>
                  <div className="flex items-center">
                    <span className="font-medium text-gray-600 mr-2">Şube:</span>
                    <span className="text-gray-800">
                      {savedStudent?.branch}
                    </span>
                  </div>
                  {savedStudent?.school && (
                    <div className="flex items-center">
                      <span className="font-medium text-gray-600 mr-2">Okul:</span>
                      <span className="text-gray-800">
                        {savedStudent?.school}
                      </span>
                    </div>
                  )}
                  <div className="flex items-center">
                    <span className="font-medium text-gray-600 mr-2">Dönem:</span>
                    <span className="text-gray-800">
                      {savedStudent?.period}
                    </span>
                  </div>
                </div>
              </div>

              {/* Success Message */}
              <div className="text-center mb-6">
                <div className="inline-flex items-center bg-green-100 text-green-800 px-4 py-2 rounded-full text-sm font-medium mb-4">
                  <FaCheckCircle className="mr-2" />
                  Kayıt işlemi {new Date().toLocaleString('tr-TR')} tarihinde tamamlandı
                </div>
                <p className="text-gray-600 text-lg">
                  <strong>{savedStudent?.name} {savedStudent?.surname}</strong> adlı öğrencinin kaydı başarıyla oluşturuldu.
                  <br />
                  Artık ödeme planını indirebilir veya öğrenci detaylarını görüntüleyebilirsiniz.
                </p>
              </div>

              {/* Action Buttons */}
              <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
                <button
                  onClick={handleDownloadPaymentPlan}
                  className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 flex items-center justify-center font-medium shadow-lg hover:shadow-xl"
                >
                  <FaFileDownload className="mr-2" />
                  Ödeme Dökümünü İndir
                </button>
                <button
                  onClick={handleViewStudentDetails}
                  className="w-full sm:w-auto px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-all duration-200 flex items-center justify-center font-medium shadow-lg hover:shadow-xl"
                >
                  <FaUser className="mr-2" />
                  Öğrenci Detaylarını Görüntüle
                </button>
              </div>

              {/* Additional Actions */}
              <div className="mt-6 pt-6 border-t border-gray-200 text-center">
                <p className="text-gray-500 text-sm mb-3">Başka bir işlem yapmak istiyor musunuz?</p>
                <div className="flex flex-col sm:flex-row justify-center gap-2 sm:gap-3">
                  <button
                    onClick={() => {
                      setIsSuccess(false);
                      setSavedStudent(null);
                      setStudent({
                        id: "",
                        name: "",
                        surname: "",
                        student_number: "",
                        period: "",
                        student_class: "",
                        registration_date: new Date().toISOString().split('T')[0], // Bugünün tarihi
                        branch: "",
                        school: "",
                        phone: "",
                        email: "",
                        photo_url: "",
                        gender: "",
                        birth_date: "",
                        tc_number: "",
                        address: "",
                        mother_name: "",
                        mother_phone: "",
                        mother_email: "",
                        mother_address: "",
                        father_name: "",
                        father_phone: "",
                        father_email: "",
                        father_address: "",
                        payment_plan: {
                          totalAmount: "",
                          installmentCount: "",
                          unpaidBills: [],
                          paidInstallments: [],
                        },
                        payment_responsible: "",
                        responsible_tc_number: "",
                        advisor_teacher: getUserNameFromToken(), // JWT'den alınan kullanıcı adı
                      });
                      setTcCheckStatus(null);
                      setTcCheckMessage('');
                    }}
                    className="px-4 py-2 text-sm text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                  >
                    ➕ Yeni Öğrenci Kaydet
                  </button>
                  <button
                    onClick={() => navigate('/student-list')}
                    className="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 hover:bg-gray-50 rounded-lg transition-colors duration-200"
                  >
                    📋 Öğrenci Listesine Git
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : error ? (
          <div className="bg-white rounded-lg shadow-lg overflow-hidden p-6">
            <div className="text-center">
              <FaExclamationTriangle className="mx-auto h-16 w-16 text-red-500 mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Hata Oluştu!
              </h2>
              <p className="text-gray-600 mb-6">{error}</p>
              <div className="flex flex-col sm:flex-row justify-center gap-2 sm:gap-4">
                <button
                  onClick={handleTryAgain}
                  className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center"
                >
                  Tekrar Dene
                </button>
                <button
                  onClick={() => setError(null)}
                  className="w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center"
                >
                  Forma Dön
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="px-3 sm:px-4 py-4 sm:py-5 lg:px-6 bg-gradient-to-r from-blue-600 to-blue-800">
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-white">
                Öğrenci Kayıt Formu
              </h2>
                              <p className="text-blue-100 text-sm mt-2">
                <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span> ile işaretli alanlar zorunludur
              </p>
            </div>
            
            {/* Bilgi Kutusu */}
            <div className="mx-3 sm:mx-4 lg:mx-6 mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-blue-800">Form Doldurmak için:</h3>
                  <div className="mt-2 text-sm text-blue-700">
                    <ul className="list-disc pl-5 space-y-1">
                                              <li>Telefon numaraları <strong>10 haneli</strong> olmalıdır ve <strong>5 ile başlamalıdır</strong> (5** *** ** **)</li>
                      <li>TC Kimlik numaraları <strong>11 haneli</strong> olmalıdır</li>
                      <li>Email adresleri geçerli format olmalıdır</li>
                      <li>Öğrenci yaşı en az <strong>5</strong> olmalıdır</li>
                      <li>Anne veya baba telefonundan <strong>en az biri</strong> zorunludur</li>
                      <li>Tüm <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span> işaretli alanlar zorunludur</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            
            <form onSubmit={handleSubmit} className="p-3 sm:p-4 lg:p-6 space-y-4 sm:space-y-6 lg:space-y-8">
              {/* Öğrenci Bilgileri */}
                              <div className="bg-gray-50 p-3 sm:p-4 lg:p-6 rounded-lg">
                  <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center">
                    <FaUser className="mr-2 text-sm sm:text-base" />
                    Öğrenci Bilgileri
                  </h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Ad <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Ad"
                      className={`w-full pl-8 sm:pl-10 pr-3 sm:pr-4 py-2 sm:py-3 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize ${
                        formErrors.name 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.name}
                      onChange={handleInputChange}
                      required
                    />
                    <FaUser className="absolute left-2 sm:left-3 top-8 sm:top-9 text-gray-400 text-sm sm:text-base" />
                    {formErrors.name && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.name}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Soyad <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <input
                      type="text"
                      name="surname"
                      placeholder="Soyad"
                      className={`w-full pl-8 sm:pl-10 pr-3 sm:pr-4 py-2 sm:py-3 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize ${
                        formErrors.surname 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.surname}
                      onChange={handleInputChange}
                      required
                    />
                    <FaUser className="absolute left-2 sm:left-3 top-8 sm:top-9 text-gray-400 text-sm sm:text-base" />
                    {formErrors.surname && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.surname}
                      </div>
                    )}
                  </div>

                                      <div className="relative">
                      <label className="block text-xs font-medium text-gray-600 mb-1">
                        Sınıf <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                      </label>
                      <select
                        name="student_class"
                        className={`w-full pl-8 sm:pl-10 pr-3 sm:pr-4 py-2 sm:py-3 text-sm sm:text-base border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                          formErrors.student_class 
                            ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                            : 'border-gray-300'
                        }`}
                        value={student.student_class}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Sınıf Seçin</option>
                        {classOptions.map(c=> (
                           <option key={c.id} value={c.class_level}>{c.class_level}. Sınıf</option>
                        ))}
                      </select>
                      <FaSchool className="absolute left-2 sm:left-3 top-8 sm:top-9 text-gray-400 text-sm sm:text-base" />
                      {formErrors.student_class && (
                        <div className="text-xs text-red-600 mt-1 flex items-center">
                          <FaExclamationTriangle className="mr-1 text-xs" />
                          {formErrors.student_class}
                        </div>
                      )}
                    </div>

                    {/* Dönem Seçimi */}
                    <div className="relative">
                      <label className="block text-xs font-medium text-gray-600 mb-1">
                        Dönem <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                      </label>
                      <select
                        name="period"
                        className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                          formErrors.period 
                            ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                            : 'border-gray-300'
                        }`}
                        value={student.period}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="">Dönem Seçin</option>
                        {periodOptions.map((p) => (
                          <option key={p} value={p}>{p}</option>
                        ))}
                      </select>
                      <FaCalendar className="absolute left-3 top-8 text-gray-400" />
                      {formErrors.period && (
                        <div className="text-xs text-red-600 mt-1 flex items-center">
                          <FaExclamationTriangle className="mr-1 text-xs" />
                          {formErrors.period}
                        </div>
                      )}
                    </div>

                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Şube <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <select
                      name="branch"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize ${
                        formErrors.branch 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.branch}
                      onChange={(e) => {
                        console.log('Branch onChange triggered:', e.target.value);
                        console.log('Current student.branch:', student.branch);
                        console.log('Available branchOptions:', branchOptions);
                        handleInputChange(e);
                      }}
                      required
                      disabled={!student.student_class || branchOptions.length === 0 || branchLoading}
                    >
                      <option value="">
                        {!student.student_class 
                          ? "Önce sınıf seçin" 
                          : branchLoading
                          ? "Şubeler yükleniyor..."
                          : branchOptions.length === 0 
                          ? "Bu sınıf için şube yok" 
                          : "Şube Seçin"
                        }
                      </option>
                      {branchOptions.map(b=> (
                        <option key={b.id} value={b.branch_name}>{b.branch_name}</option>
                      ))}
                    </select>
                    <FaSchool className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.branch && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.branch}
                      </div>
                    )}
                    {student.student_class && branchOptions.length === 0 && (
                      <div className="text-xs text-orange-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        Bu sınıf için henüz şube eklenmemiş. Admin panelinden şube ekleyiniz.
                      </div>
                    )}
                  </div>
                  
                  {/* Okul Seçimi */}
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Okul
                    </label>
                    <select
                      name="school"
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      value={student.school}
                      onChange={handleInputChange}
                    >
                      <option value="">Okul Seçin</option>
                      <option value="Cumhuriyet Ortaokulu">Cumhuriyet Ortaokulu</option>
                      <option value="31 Ağustos Ortaokulu">31 Ağustos Ortaokulu</option>
                      <option value="İmam Hatip Ortaokulu">İmam Hatip Ortaokulu</option>
                      <option value="Halime Ali Kaya Ortaokulu">Halime Ali Kaya Ortaokulu</option>
                      <option value="Diğer">Diğer</option>
                    </select>
                    <FaSchool className="absolute left-3 top-8 text-gray-400" />
                  </div>
                  
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      TC Kimlik No <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <input
                      type="text"
                      name="tc_number"
                      placeholder="TC Kimlik No (11 haneli)"
                      className={`w-full pl-10 pr-12 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.tc_number
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : tcCheckStatus === 'available'
                          ? 'border-green-500 bg-green-50'
                          : 'border-gray-300'
                      }`}
                      value={student.tc_number}
                      onChange={handleInputChange}
                      maxLength="11"
                      pattern="[0-9]{11}"
                      title="11 haneli TC kimlik numarası giriniz"
                      required
                    />
                    <FaIdCard className="absolute left-3 top-8 text-gray-400" />
                    
                    {/* TC Check Status Icon */}
                    {tcCheckStatus && (
                      <div className="absolute right-3 top-8">
                        {tcCheckStatus === 'checking' && (
                          <svg className="animate-spin h-4 w-4 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                        )}
                        {tcCheckStatus === 'available' && (
                          <FaCheckCircle className="h-4 w-4 text-green-500" />
                        )}
                        {tcCheckStatus === 'unavailable' && (
                          <FaExclamationTriangle className="h-4 w-4 text-red-500" />
                        )}
                        {tcCheckStatus === 'error' && (
                          <FaExclamationTriangle className="h-4 w-4 text-yellow-500" />
                        )}
                      </div>
                    )}
                    
                    {/* TC Validation Messages */}
                    {formErrors.tc_number && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.tc_number}
                      </div>
                    )}
                    {tcCheckMessage && student.tc_number.length === 11 && !formErrors.tc_number && (
                      <div className={`text-xs mt-1 ${
                        tcCheckStatus === 'available' 
                          ? 'text-green-600' 
                          : tcCheckStatus === 'unavailable' 
                          ? 'text-red-600'
                          : tcCheckStatus === 'checking'
                          ? 'text-blue-600'
                          : 'text-yellow-600'
                      }`}>
                        {tcCheckMessage}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Telefon
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      placeholder="(0***) *** ** **"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.phone 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.phone}
                      onChange={handleInputChange}
                      maxLength="16"
                      title="Telefon numarası giriniz (5** *** ** **)"
                    />
                    <FaPhone className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.phone && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.phone}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      E-posta
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="E-posta"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.email 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.email}
                      onChange={handleInputChange}
                    />
                    <FaEnvelope className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.email && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.email}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Doğum Tarihi
                    </label>
                    <FaCalendar 
                      className="absolute left-3 top-8 text-gray-400 cursor-pointer hover:text-blue-500" 
                      onClick={() => {
                        const input = document.querySelector('input[name="birth_date"]');
                        if (input) {
                          input.focus();
                          input.click();
                        }
                      }}
                    />
                    <input
                      type="date"
                      name="birth_date"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer ${
                        formErrors.birth_date 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.birth_date}
                      onChange={handleInputChange}
                      placeholder="GG.AA.YYYY"
                      style={{ colorScheme: 'light' }}
                    />
                    {formErrors.birth_date && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.birth_date}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Cinsiyet <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <select
                      name="gender"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.gender 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.gender}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Cinsiyet Seçin</option>
                      <option value="male">Erkek</option>
                      <option value="female">Kadın</option>
                    </select>
                    <FaUser className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.gender && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.gender}
                      </div>
                    )}
                  </div>
                  <div className="relative col-span-full">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Adres
                    </label>
                    <input
                      type="text"
                      name="address"
                      placeholder="Adres"
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize"
                      value={student.address}
                      onChange={handleInputChange}
                    />
                    <FaMapMarkerAlt className="absolute left-3 top-8 text-gray-400" />
                  </div>
                  <div className="relative">
                    <label className="block text-xs sm:text-sm font-medium text-gray-600 mb-1" htmlFor="reg_date">
                      Kayıt Tarihi
                      {userRole === "user" && (
                        <span className="text-orange-600 text-xs ml-2">(Personel sadece bugünün tarihini seçebilir)</span>
                      )}
                    </label>
                    <input
                      type="date"
                      id="reg_date"
                      name="registration_date"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.registration_date 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.registration_date}
                      onChange={handleInputChange}
                      min={userRole === "user" ? new Date().toISOString().split('T')[0] : "1900-01-01"}
                      max={userRole === "user" ? new Date().toISOString().split('T')[0] : "2099-12-31"}
                    />
                    <FaCalendarAlt className="absolute left-3 top-8 sm:top-9 text-gray-400" />
                    {formErrors.registration_date && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.registration_date}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Anne Bilgileri */}
              <div className="bg-gray-50 p-3 sm:p-4 lg:p-6 rounded-lg">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center">
                  <FaUser className="mr-2 text-sm sm:text-base" />
                  Anne Bilgileri
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 lg:gap-6">
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Anne Adı-Soyadı <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <input
                      type="text"
                      name="mother_name"
                      placeholder="Anne Adı-Soyadı"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize ${
                        formErrors.mother_name 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.mother_name}
                      onChange={handleInputChange}
                      required
                    />
                    <FaUser className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.mother_name && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.mother_name}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Anne Telefonu <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <input
                      type="tel"
                      name="mother_phone"
                      placeholder="(0***) *** ** **"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.mother_phone 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.mother_phone}
                      onChange={handleInputChange}
                      maxLength="16"
                      title="Telefon numarası giriniz (5** *** ** **)"
                      required
                    />
                    <FaPhone className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.mother_phone && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.mother_phone}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Anne E-posta
                    </label>
                    <input
                      type="email"
                      name="mother_email"
                      placeholder="E-posta"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.mother_email 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.mother_email}
                      onChange={handleInputChange}
                    />
                    <FaEnvelope className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.mother_email && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.mother_email}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Anne Adres
                    </label>
                    <input
                      type="text"
                      name="mother_address"
                      placeholder="Adres"
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize"
                      value={student.mother_address}
                      onChange={handleInputChange}
                    />
                    <FaMapMarkerAlt className="absolute left-3 top-8 text-gray-400" />
                  </div>
                </div>
              </div>

              {/* Baba Bilgileri */}
              <div className="bg-gray-50 p-3 sm:p-4 lg:p-6 rounded-lg">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center">
                  <FaUser className="mr-2 text-sm sm:text-base" />
                  Baba Bilgileri
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 lg:gap-6">
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Baba Adı-Soyadı <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <input
                      type="text"
                      name="father_name"
                      placeholder="Baba Adı-Soyadı"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize ${
                        formErrors.father_name 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.father_name}
                      onChange={handleInputChange}
                      required
                    />
                    <FaUser className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.father_name && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.father_name}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Baba Telefonu <span style={{color: '#ff4444', fontWeight: 'bold'}}>*</span>
                    </label>
                    <input
                      type="tel"
                      name="father_phone"
                      placeholder="(0***) *** ** **"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.father_phone 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.father_phone}
                      onChange={handleInputChange}
                      maxLength="16"
                      title="Telefon numarası giriniz (5** *** ** **)"
                      required
                    />
                    <FaPhone className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.father_phone && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.father_phone}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Baba E-posta
                    </label>
                    <input
                      type="email"
                      name="father_email"
                      placeholder="E-posta"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.father_email 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.father_email}
                      onChange={handleInputChange}
                    />
                    <FaEnvelope className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.father_email && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.father_email}
                      </div>
                    )}
                  </div>
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Baba Adres
                    </label>
                    <input
                      type="text"
                      name="father_address"
                      placeholder="Adres"
                      className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent capitalize"
                      value={student.father_address}
                      onChange={handleInputChange}
                    />
                    <FaMapMarkerAlt className="absolute left-3 top-8 text-gray-400" />
                  </div>
                </div>
              </div>

              {/* Ödeme Sorumlusu */}
              <div className="bg-gray-50 p-3 sm:p-4 lg:p-6 rounded-lg">
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center">
                  <FaUser className="mr-2 text-sm sm:text-base" />
                  Ödeme Sorumlusu
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 lg:gap-6">
                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Ödeme Sorumlusu
                    </label>
                    <select
                      name="payment_responsible"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.payment_responsible 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.payment_responsible}
                      onChange={handleInputChange}
                    >
                      <option value="">Sorumlu Seçin</option>
                      <option value="mother">Anne</option>
                      <option value="father">Baba</option>
                    </select>
                    <FaUser className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.payment_responsible && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.payment_responsible}
                      </div>
                    )}
                  </div>

                  <div className="relative">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Sorumlu TC Kimlik No
                    </label>
                    <input
                      type="text"
                      name="responsible_tc_number"
                      placeholder="Sorumlu TC Kimlik No (11 haneli)"
                      className={`w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
                        formErrors.responsible_tc_number 
                          ? 'border-red-500 bg-red-50 focus:ring-red-500' 
                          : 'border-gray-300'
                      }`}
                      value={student.responsible_tc_number}
                      onChange={handleInputChange}
                      maxLength="11"
                      pattern="[0-9]{11}"
                      title="11 haneli TC kimlik numarası giriniz"
                    />
                    <FaIdCard className="absolute left-3 top-8 text-gray-400" />
                    {formErrors.responsible_tc_number && (
                      <div className="text-xs text-red-600 mt-1 flex items-center">
                        <FaExclamationTriangle className="mr-1 text-xs" />
                        {formErrors.responsible_tc_number}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Modal için Sözleşme */}
              {isModalOpen && (
                <ContractModal
                  isOpen={true}
                  onClose={handleCloseModal}
                  onSave={handleSaveContract}
                />
              )}

              <div className="flex justify-center sm:justify-end">
                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  className={`w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 text-sm sm:text-base rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-200 flex items-center justify-center ${
                    isSubmitting
                      ? "bg-gray-400 cursor-not-allowed text-gray-200"
                      : "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500 hover:shadow-lg"
                  }`}
                >
                  {isSubmitting ? (
                    <>
                      <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-gray-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Kontrol Ediliyor...
                    </>
                  ) : (
                    <>
                      <FaCheckCircle className="mr-2" />
                      Sözleşmeyi Oluştur
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default StudentRegistration;
